import { render } from "./StaffingRequirementAdd.vue?vue&type=template&id=1ab354de&scoped=true"
import script from "./StaffingRequirementAdd.vue?vue&type=script&lang=js"
export * from "./StaffingRequirementAdd.vue?vue&type=script&lang=js"

import "./StaffingRequirementAdd.vue?vue&type=style&index=0&id=1ab354de&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ab354de"]])

export default __exports__